import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Printer } from "@phosphor-icons/react";
import { GUIDES } from "@/data/guides";

export default function Guides({ defaultTab = "struttura" }) {
  const [tab, setTab] = useState(defaultTab);
  const g = GUIDES[tab];
  const print = () => {
    const w = window.open("", "_blank");
    if (!w) return window.print();
    w.document.write(`<html><head><title>${g.title} · Otelya</title><style>body{font-family:Georgia,serif;color:#1c211e;max-width:720px;margin:32px auto;padding:0 20px;line-height:1.5}h2{font-size:26px}.k{font:11px sans-serif;letter-spacing:.15em;text-transform:uppercase;color:#b65b47;margin-top:24px}li{margin:6px 0;font:14px sans-serif}</style></head><body>${document.querySelector(`[data-testid="guide-${tab}"]`).innerHTML}</body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 300);
  };
  return (
    <div className="rounded-2xl border border-line bg-canvas p-6 space-y-5 print:border-0 print:p-0" data-testid="guides">
      <div className="flex flex-wrap items-center gap-2 print:hidden">
        {Object.entries(GUIDES).map(([k, v]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`guide-tab-${k}`}
            className={`text-sm px-4 py-1.5 rounded-full border transition-colors ${tab === k ? "bg-ink text-canvas border-ink" : "border-line text-stone hover:text-ink"}`}>{v.title}</button>
        ))}
        <Button variant="outline" className="rounded-full ml-auto" onClick={print} data-testid="guide-print-btn"><Printer size={16} className="mr-1" />Scarica PDF</Button>
      </div>
      <div data-testid={`guide-${tab}`}>
        <h2 className="font-serif text-2xl text-ink">{g.title}</h2>
        <p className="text-sm text-stone mt-1 max-w-3xl">{g.intro}</p>
        {g.sections.map((s) => (
          <div key={s.h} className="mt-6 break-inside-avoid">
            <div className="text-xs uppercase tracking-widest text-terracotta mb-2">{s.h}</div>
            <ol className="space-y-2">
              {s.steps.map(([t, d], i) => (
                <li key={t} className="flex items-baseline gap-3 text-sm">
                  <span className="font-serif text-lg text-gold w-5 shrink-0">{i + 1}</span>
                  <span><b className="text-ink">{t}</b> <span className="text-ink/80">— {d}</span></span>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </div>
  );
}
